<div
  class="alerts-table"
  [attr.disabled]="disableAlerts ? disableAlerts : null"
>
  <div class="col">
    <div class="header">
      Email Alerts
    </div>
    <div class="body">
      <nz-checkbox-wrapper
        style="width: 100%;"
        class="check-box-group event-list"
      >
        <div class="event-item" *ngFor="let data of allEventTypes">
          <label
            nz-checkbox
            nzValue="{{ data.display_name }}"
            [(ngModel)]="data.default_check_in_watchlist"
            (ngModelChange)="onClickEventType(data)"
            class="checkbox-label"
            >{{ data.display_name }}</label
          >

          <div
            *ngIf="data.display_name === 'Earnings Preview'"
            class="info-line"
          >
            <va-icon isFontAwesome="true" [name]="faInfoCircle"></va-icon>
            <div class="info-text">
              Receive a snapshot of consensus estimates before earnings.
            </div>
          </div>

          <div *ngIf="data.display_name === 'New Consensus'" class="info-line">
            <va-icon isFontAwesome="true" [name]="faInfoCircle"></va-icon>
            <div class="info-text">
              Only apply to company without consensus.
            </div>
          </div>

          <div
            *ngIf="data.subcategories && data.subcategories.length > 0"
            class="sub-values"
          >
            <nz-checkbox-wrapper
              style="width: 100%;"
              (nzOnChange)="onEPChanges()"
              class="check-box-group"
            >
              <span
                class="checkbox-sm"
                *ngFor="let subVal of data.subcategories"
              >
                <label
                  nz-checkbox
                  nzValue="{{ subVal.display_name }}"
                  [(ngModel)]="subVal.default_check_in_watchlist"
                  class="checkbox-label"
                  >{{ subVal.display_name }}</label
                >
              </span>
            </nz-checkbox-wrapper>
          </div>
          <ng-container *ngIf="data.display_name === 'New Model'">
            <div class="broker-search" *ngIf="isBrokerListVisible">
              <nz-input-group [nzSuffix]="suffixTemplate" nzSize="small">
                <input
                  type="text"
                  nz-input
                  [(ngModel)]="brokerSearchText"
                  placeholder="Search Broker"
                  (ngModelChange)="onBrokerSearchChange()"
                />
              </nz-input-group>
              <ng-template #suffixTemplate>
                <i
                  nz-icon
                  nz-tooltip
                  class="ant-input-clear-icon"
                  nzTheme="fill"
                  nzType="close-circle"
                  *ngIf="brokerSearchText"
                  (click)="onClearBrokerSearch()"
                ></i>
              </ng-template>
            </div>
            <div class="broker-list-label" (click)="onClickViewAllBrokers()">
              <va-icon isFontAwesome="true"
                [name]="!isBrokerListVisible ? faCaretDown : faCaretUp"
              ></va-icon>
              <span style="padding-left: 5px;" [hidden]="isBrokerListVisible"
                >View All {{ brokerList.length }} Brokers</span
              >
              <span style="padding-left: 5px;" [hidden]="!isBrokerListVisible"
                >Close Brokers Detail</span
              >
            </div>
            <div class="broker-list" [hidden]="!isBrokerListVisible">
              <span class="checkbox-sm" style="width: 100%;">
                <label
                  nz-checkbox
                  nzValue="allEntitled"
                  [(ngModel)]="allEntitled"
                  (ngModelChange)="onChangeAllEntitled()"
                  class="checkbox-label"
                  >All Entitled</label
                >
              </span>
              <nz-checkbox-wrapper
                style="width: 100%;"
                (nzOnChange)="onBrokerChanges($event, 'brokerChange')"
                class="check-box-group"
              >
                <span
                  class="checkbox-sm"
                  *ngFor="let broker of brokerList"
                  [hidden]="!broker.visible"
                >
                  <label
                    nz-checkbox
                    nzValue="{{ broker.label }}"
                    [(ngModel)]="broker.checked"
                    class="checkbox-label"
                    >{{ broker.label }}</label
                  >
                </span>
              </nz-checkbox-wrapper>
            </div>
          </ng-container>
        </div>
      </nz-checkbox-wrapper>
    </div>
  </div>
  <div class="col">
    <div class="header">
      Email Sending Frequency
    </div>
    <div class="body">
      <nz-checkbox-wrapper
        style="width: 100%;"
        (nzOnChange)="onNotificationChanges($event)"
        class="check-box-group frequency-list"
      >
        <div class="frequency-item">
          <label
            nz-checkbox
            nzValue="instant"
            [(ngModel)]="notificationOptions.instant"
            class="checkbox-label"
            >As it Happens</label
          >
        </div>
        <div class="frequency-item">
          <label
            nz-checkbox
            nzValue="daily"
            [(ngModel)]="notificationOptions.daily"
            class="checkbox-label"
            >Daily Digest</label
          >
        </div>
        <div class="frequency-item">
          <label
            nz-checkbox
            nzValue="weekly"
            [(ngModel)]="notificationOptions.weekly"
            class="checkbox-label"
            >Weekly Digest</label
          >
        </div>
      </nz-checkbox-wrapper>
    </div>
  </div>
</div>
